import React from 'react';
import cn from 'clsx';
import { SectionSubTitle, SectionTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import { StepStructure } from './steps-section-constants';
import {
  shortStepContainer,
  shortStepList,
  stepContainer,
  stepDescription,
  stepList,
  stepName,
  stepNumber,
  stepNumberWrapper,
  stepsSection,
  stepsSectionTitle,
} from './steps-section-styles';

type StepsSectionProps = {
  shortSteps?: boolean;
  stepSectionList: StepStructure[];
  stepNameVariant?: 'h3' | 'h2';
};

/**
 * Вью секции с шагами по созданию инженерных систем
 */
export const StepsSection: React.FC<StepsSectionProps> = ({
  shortSteps = false,
  stepNameVariant = 'h2',
  stepSectionList,
}) => (
  <section className={stepsSection}>
    <SectionTitle className={stepsSectionTitle}>
      {stepSectionList.length}&nbsp;шага до&nbsp;готовой системы
    </SectionTitle>
    <div className={cn(stepList, { [shortStepList]: shortSteps })}>
      {stepSectionList.map(({ title, description }: StepStructure, index: number) => (
        <div
          className={cn(stepContainer, { [shortStepContainer]: shortSteps })}
          key={createElementKey('step', index)}>
          <div className={stepNumberWrapper}>
            <span className={stepNumber}>{index + 1}</span>
          </div>
          <div>
            <SectionSubTitle as="h3" className={stepName} margin="s" variant={stepNameVariant}>
              {title}
            </SectionSubTitle>
            <Typography className={stepDescription} variant="m" size="body_long">
              {description}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  </section>
);
